export default {
	DEFAULT_TEXT: 'CMS only',
	IS_COLLAPSED: 'collapsed',
	HOVER_HELP_TEXT:
		"This is only visible in Sitecore's Experience Editor for ease-of-authoring.",

	BUTTONS: {
		DISMISS: 'Dismiss',
		TOGGLE_COLLAPSE: 'Toggle collapse content',
	},
};
